import { createSlice } from '@reduxjs/toolkit';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  // datas
  empowerments: [],
  degrees: [],
  languages: [],
  selectionDegrees: [],
  selectionLanguages: [],
  selectionEmpowerments: [],
  // login email
  emailLogin: '',
  isBusinessCardActivated: false
};

const slice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setEmailLogin(state, action) {
      state.emailLogin = action.payload;
    },
    setSelectionDegrees(state, action) {
      state.selectionDegrees = action.payload;
    },
    setSelectionLanguages(state, action) {
      state.selectionLanguages = action.payload;
    },
    setSelectionEmpowerments(state, action) {
      state.selectionEmpowerments = action.payload;
    },

    getInfosCandidate(state, action) {
      const { empowerments, degrees, languages, is_business_card_activated } = action.payload;
      state.isLoading = false;
      state.empowerments = empowerments;
      state.degrees = degrees;
      state.languages = languages;
      state.isBusinessCardActivated = Boolean(is_business_card_activated);
    },

    postCandidate(state) {
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;
// actions
export const { setSelectionDegrees, setSelectionLanguages, setSelectionEmpowerments, setEmailLogin } = slice.actions;

export function getInfosCandidate() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/candidate/details');
      dispatch(slice.actions.getInfosCandidate(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postCandidate(form, callback) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let body = null;
      const keysForm = Object.keys(form);
      body = new FormData();
      keysForm.forEach((key) => {
        if (!['cv', 'letter', 'photo'].includes(key)) {
          if (form[key] !== null && form[key] !== undefined && !key.includes('_chain')) {
            body.append(key, form[key]);
          }
          if (key.includes('_chain')) {
            let chain = form[key].map((el) => el.id).join('/');
            if (chain.length > 0) {
              chain = `/${chain}/`;
            }

            body.append(key, chain);
          }
        }
      });

      if (form.cv && form.cv.length) {
        body.append('files[cv]', form.cv[0]);
      }
      if (form.letter && form.letter.length) {
        body.append('files[letter]', form.letter[0]);
      }
      if (form.photo && form.photo.length) {
        body.append('files[photo]', form.photo[0]);
      }

      const response = await fetch(`${socket.apiUrl}/candidate`, { method: 'POST', body });

      // if (response.status !== 200) {
      if (!response.ok) {
        throw new Error('Une erreur est survenue.');
      }

      const result = await response.json();
      dispatch(slice.actions.postCandidate(result));

      callback(result);
    } catch (err) {
      console.error(err);
      callback(err);

      dispatch(slice.actions.hasError(err));
    }
  };
}
